import React from 'react';
import ReviewDashboard from '../../features/Dashboard/components/Review/components/ReviewDashboard/ReviewDashboard';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
const Review = () => {
  return (
    <>
      <ProtectedPageSidebar />
      <ReviewDashboard />
    </>
  );
};

export default Review;
